





































import { Component, Vue } from "vue-property-decorator";
import BBService from "@/services/BBService";

@Component({
  components: {},
})
export default class VaultView extends Vue {
  private bbs = new BBService();
  private holdings: any = [];

  private loading = false;

  private mounted() {
    this.getCards();
  }

  private getCards() {
    this.loading = true;

    this.bbs.getVault().then((response) => {
      const cards = response.results;

      this.holdings = cards;
      this.loading = false;
    });
  }
}
